// Local SEO landing pages — Edmonton area communities & neighbourhoods.
// Each entry has unique copy to avoid duplicate-content issues.

export const SERVICE_AREAS = [
  {
    slug: "sherwood-park",
    name: "Sherwood Park",
    kind: "Community",
    label: "Strathcona County",
    intro:
      "Classic Interior Renovations brings full-service kitchen, bathroom, basement and whole-home remodeling to Sherwood Park. From established homes in Broadmoor and Glen Allan to newer builds in Summerwood and Aspen Trails, we help Strathcona County families modernize the spaces they use every day.",
    note:
      "Many Sherwood Park homes were built in the 1970s–90s and are ideal candidates for opening up dated floor plans, refreshing kitchens and finishing basements for growing families.",
    nearby: ["beaumont", "riverbend", "terwillegar"],
  },
  {
    slug: "st-albert",
    name: "St. Albert",
    kind: "Community",
    label: "Greater Edmonton",
    intro:
      "Serving St. Albert homeowners with premium interior renovations — thoughtful kitchen and bathroom remodels, basement developments and complete home transformations. Whether you're in Grandin, Lacombe Park or Erin Ridge, we deliver craftsmanship that respects the character of your home.",
    note:
      "St. Albert's mature, tree-lined neighbourhoods often feature generous lots and solid homes that reward careful, high-quality renovation over rebuild.",
    nearby: ["spruce-grove", "glenora", "windermere"],
  },
  {
    slug: "spruce-grove",
    name: "Spruce Grove",
    kind: "Community",
    label: "Parkland County",
    intro:
      "Classic Interior Renovations proudly serves Spruce Grove with expert kitchen renovations, bathroom remodels, basement finishing and full-home projects. From Deer Park to Spruce Village and the newer Greenbury and Hawthorne communities, we build interiors that fit how you live.",
    note:
      "Spruce Grove's mix of established and fast-growing communities means we handle everything from full basement developments to complete refreshes of older bungalows.",
    nearby: ["st-albert", "leduc", "windermere"],
  },
  {
    slug: "leduc",
    name: "Leduc",
    kind: "Community",
    label: "Leduc County",
    intro:
      "We bring premium renovation services to Leduc homeowners — modern kitchens, spa-inspired bathrooms, finished basements and whole-home remodels. From Robinson and West Haven to Southfork and Bridgeport, we help Leduc families get more from their homes.",
    note:
      "With many newer homes in Leduc, we frequently finish basements into legal suites, media rooms and additional bedrooms to add lasting value.",
    nearby: ["beaumont", "spruce-grove", "summerside"],
  },
  {
    slug: "beaumont",
    name: "Beaumont",
    kind: "Community",
    label: "Greater Edmonton",
    intro:
      "Classic Interior Renovations serves Beaumont with high-end kitchen and bathroom remodels, basement developments and full-home renovations. From Montrose and Coloniale to Dansereau Meadows, we deliver detail-driven craftsmanship close to home.",
    note:
      "Beaumont's rapid growth brings many newer homes ready for basement development and personalized upgrades that make a builder-grade house truly your own.",
    nearby: ["leduc", "sherwood-park", "summerside"],
  },
  {
    slug: "glenora",
    name: "Glenora",
    kind: "Edmonton neighbourhood",
    label: "West Edmonton",
    intro:
      "In one of Edmonton's most prestigious neighbourhoods, Classic Interior Renovations delivers renovations worthy of Glenora's character homes. We specialize in respectful kitchen and bathroom remodels, main-floor reconfigurations and full-home projects that honour heritage while adding modern comfort.",
    note:
      "Glenora's stately older homes call for renovation partners who understand character detailing, plaster, hardwood and thoughtful structural work — exactly our specialty.",
    nearby: ["windermere", "riverbend", "st-albert"],
  },
  {
    slug: "windermere",
    name: "Windermere",
    kind: "Edmonton neighbourhood",
    label: "Southwest Edmonton",
    intro:
      "Serving Windermere's luxury homes with premium interior renovations — designer kitchens, spa bathrooms, custom basements and complete home remodels. We match the calibre of Edmonton's finest southwest estates with meticulous craftsmanship.",
    note:
      "Windermere's larger, newer estate homes are perfect for custom cabinetry, high-end finishes, home theatres and refined whole-home upgrades.",
    nearby: ["terwillegar", "riverbend", "glenora"],
  },
  {
    slug: "terwillegar",
    name: "Terwillegar",
    kind: "Edmonton neighbourhood",
    label: "Southwest Edmonton",
    intro:
      "Classic Interior Renovations serves Terwillegar Towne and the surrounding southwest communities with kitchen and bathroom remodels, basement developments and full-home renovations designed around busy family life.",
    note:
      "Terwillegar's family-focused homes are ideal for finishing basements into flexible living space and updating open-plan kitchens for entertaining.",
    nearby: ["windermere", "riverbend", "summerside"],
  },
  {
    slug: "riverbend",
    name: "Riverbend",
    kind: "Edmonton neighbourhood",
    label: "Southwest Edmonton",
    intro:
      "We bring premium renovations to Riverbend's established southwest communities — Brander Gardens, Ramsay Heights, Falconer Heights and beyond. Expect thoughtful kitchen and bathroom remodels, basement development and whole-home transformations.",
    note:
      "Riverbend's mature homes near the river valley are excellent candidates for opening up living spaces and modernizing dated interiors while keeping their prized location.",
    nearby: ["terwillegar", "windermere", "glenora"],
  },
  {
    slug: "summerside",
    name: "Summerside",
    kind: "Edmonton neighbourhood",
    label: "Southeast Edmonton",
    intro:
      "Classic Interior Renovations serves Summerside and southeast Edmonton with modern kitchen and bathroom remodels, basement finishing and full-home renovations tailored to this popular lake community.",
    note:
      "Summerside's newer homes are perfect for basement developments, added bedrooms and personalized finishes that elevate a builder-grade layout.",
    nearby: ["terwillegar", "beaumont", "leduc"],
  },
  {
    slug: "fort-saskatchewan",
    name: "Fort Saskatchewan",
    kind: "Community",
    label: "Greater Edmonton",
    intro:
      "Classic Interior Renovations serves Fort Saskatchewan with full-service kitchen and bathroom remodels, basement development and whole-home renovations. From Southfort and Sienna to established riverside neighbourhoods, we help homeowners get more from their space.",
    note:
      "Fort Saskatchewan's mix of newer subdivisions and mature homes makes it ideal for both basement developments and full modernizations.",
    nearby: ["gibbons", "sherwood-park", "morinville"],
  },
  {
    slug: "stony-plain",
    name: "Stony Plain",
    kind: "Community",
    label: "Parkland County",
    intro:
      "We bring premium interior renovations to Stony Plain — thoughtful kitchen and bathroom remodels, finished basements and complete home transformations that respect the character of this charming community.",
    note:
      "Stony Plain's blend of heritage homes and new builds rewards renovation partners who can balance character with modern function.",
    nearby: ["spruce-grove", "devon", "st-albert"],
  },
  {
    slug: "devon",
    name: "Devon",
    kind: "Community",
    label: "Leduc County",
    intro:
      "Classic Interior Renovations proudly serves Devon with expert kitchen renovations, bathroom remodels, basement finishing and full-home projects tailored to this close-knit river valley town.",
    note:
      "Devon's established, well-built homes are excellent candidates for opening up dated layouts and finishing basements into functional living space.",
    nearby: ["leduc", "stony-plain", "spruce-grove"],
  },
  {
    slug: "morinville",
    name: "Morinville",
    kind: "Community",
    label: "Sturgeon County",
    intro:
      "Serving Morinville homeowners with modern kitchen and bathroom remodels, basement developments and whole-home renovations designed around comfortable family living.",
    note:
      "Morinville's growing communities feature many newer homes ideal for basement development and personalized upgrades.",
    nearby: ["gibbons", "st-albert", "fort-saskatchewan"],
  },
  {
    slug: "gibbons",
    name: "Gibbons",
    kind: "Community",
    label: "Sturgeon County",
    intro:
      "Classic Interior Renovations serves Gibbons with premium kitchen, bathroom, basement and full-home renovations — bringing city-calibre craftsmanship to this welcoming community north of Edmonton.",
    note:
      "Gibbons homes often sit on generous lots, making them great candidates for spacious, well-planned renovations and additions.",
    nearby: ["morinville", "fort-saskatchewan", "st-albert"],
  },
  {
    slug: "rutherford",
    name: "Rutherford",
    kind: "Edmonton neighbourhood",
    label: "Southwest Edmonton",
    intro:
      "We bring premium renovations to Rutherford's family-focused southwest community — modern kitchen and bathroom remodels, basement developments and full-home upgrades built around busy households.",
    note:
      "Rutherford's newer homes are perfect for finishing basements and personalizing open-plan main floors for growing families.",
    nearby: ["ellerslie", "terwillegar", "summerside"],
  },
  {
    slug: "cameron-heights",
    name: "Cameron Heights",
    kind: "Edmonton neighbourhood",
    label: "West Edmonton",
    intro:
      "Serving Cameron Heights' luxury homes with high-end interior renovations — designer kitchens, spa bathrooms, custom basements and complete remodels worthy of this prestigious river valley enclave.",
    note:
      "Cameron Heights' estate homes call for refined finishes, custom cabinetry and meticulous craftsmanship — our specialty.",
    nearby: ["crestwood", "windermere", "glenora"],
  },
  {
    slug: "griesbach",
    name: "Griesbach",
    kind: "Edmonton neighbourhood",
    label: "North Edmonton",
    intro:
      "Classic Interior Renovations serves Griesbach with modern kitchen and bathroom remodels, basement finishing and full-home renovations tailored to this vibrant, walkable north-side community.",
    note:
      "Griesbach's newer homes are ideal for basement developments and stylish, functional upgrades that elevate a builder-grade layout.",
    nearby: ["belgravia", "glenora", "st-albert"],
  },
  {
    slug: "laurel",
    name: "Laurel",
    kind: "Edmonton neighbourhood",
    label: "Southeast Edmonton",
    intro:
      "We serve Laurel and southeast Edmonton with kitchen and bathroom remodels, basement developments and whole-home renovations designed for modern family life.",
    note:
      "Laurel's newer homes are perfect for finishing basements into extra bedrooms, media rooms and flexible living space.",
    nearby: ["ellerslie", "summerside", "rutherford"],
  },
  {
    slug: "crestwood",
    name: "Crestwood",
    kind: "Edmonton neighbourhood",
    label: "West Edmonton",
    intro:
      "Classic Interior Renovations delivers character-respecting renovations to Crestwood's established west-end homes — kitchen and bathroom remodels, main-floor reconfigurations and full-home transformations.",
    note:
      "Crestwood's mature, sought-after homes reward careful renovation that blends timeless character with modern comfort.",
    nearby: ["glenora", "cameron-heights", "belgravia"],
  },
  {
    slug: "oliver",
    name: "Oliver (Wîhkwêntôwin)",
    kind: "Edmonton neighbourhood",
    label: "Central Edmonton",
    intro:
      "Serving Oliver (Wîhkwêntôwin) with premium condo and home renovations — smart kitchen and bathroom remodels and full interior transformations designed for stylish central Edmonton living.",
    note:
      "Oliver's mix of condos and character homes calls for space-savvy design and high-impact finishes in central locations.",
    nearby: ["glenora", "belgravia", "crestwood"],
  },
  {
    slug: "belgravia",
    name: "Belgravia",
    kind: "Edmonton neighbourhood",
    label: "South-Central Edmonton",
    intro:
      "Classic Interior Renovations serves Belgravia's prized university-area homes with thoughtful kitchen and bathroom remodels, basement development and full-home renovations that honour character while adding comfort.",
    note:
      "Belgravia's established homes near the river valley are excellent candidates for respectful, high-quality modernization.",
    nearby: ["crestwood", "glenora", "oliver"],
  },
  {
    slug: "ellerslie",
    name: "Ellerslie",
    kind: "Edmonton neighbourhood",
    label: "Southeast Edmonton",
    intro:
      "We bring premium renovations to Ellerslie's growing southeast communities — modern kitchen and bathroom remodels, basement finishing and full-home upgrades tailored to family living.",
    note:
      "Ellerslie's newer homes are ideal for basement developments and personalized finishes that make a house truly yours.",
    nearby: ["summerside", "laurel", "rutherford"],
  },
];

export const AREA_SERVICES = [
  { title: "Kitchen Renovations", to: "/services/kitchen", desc: "Functional, beautiful kitchens designed as the heart of the home." },
  { title: "Bathroom Renovations", to: "/services/bathroom", desc: "Spa-inspired ensuites and family bathrooms built to last." },
  { title: "Basement Development", to: "/services/basement", desc: "Turn unused space into living space, suites and more." },
  { title: "Legal Suites", to: "/services/legal-suites", desc: "Code-compliant secondary suites for rental income or family." },
  { title: "Full Home Remodeling", to: "/services/full-home", desc: "One team, one vision for your entire home." },
];

export const findArea = (slug) => SERVICE_AREAS.find((a) => a.slug === slug);
